<script>
import { aggregatedEmailTemplates } from '@/api/broadcasts/emailTemplates';

export default {
    name: 'FetchSavedTemplatesByPage',

    props: {
        variables: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            nextPageNumber: null,
            results: [],
            isLoading: false,
            isFullyLoaded: false,
            error: null,
            requestCounter: 0,
        };
    },

    created() {
        this.fetchPage();
    },

    watch: {
        variables() {
            this.reload();
        },
    },

    methods: {
        async fetchPage() {
            this.isLoading = true;

            try {
                this.requestCounter++;

                const localCounter = this.requestCounter;
                const res = await aggregatedEmailTemplates(this.nextPageNumber, this.variables);

                if (localCounter !== this.requestCounter) return;

                const {
                    nextPageToken: nextPage,
                    templates,
                } = res;

                const results = (templates || [])?.map((template) => (
                    {
                        id: template.id,
                        name: template.name,
                        html: template.html,
                        htmlPreviewUrl: template.htmlPreviewUrl,
                        templateType: template.templateType,
                        design: template.design,
                    }
                ));

                this.results.push(...results);
                this.nextPageNumber = nextPage;
                this.isFullyLoaded = !nextPage;
                this.error = null;
                this.$emit('templates-fetched', results);
            } catch (error) {
                this.error = error;
                this.$emit('error', error);
            }

            this.isLoading = false;
        },

        async reload() {
            this.nextPageNumber = null;
            this.results = [];
            this.isLoading = false;
            this.isFullyLoaded = false;
            this.error = null;

            await this.fetchPage();
        },
    },

    render() {
        const {
            nextPageNumber,
            results,
            isLoading,
            isFullyLoaded,
            error,
            fetchPage,
            reload,
        } = this;

        return this.$scopedSlots.default({
            nextPageNumber,
            results,
            isLoading,
            isFullyLoaded,
            error,
            fetchPage,
            reload,
        });
    },
};
</script>
